module.exports = __webpack_public_path__ + "static/img/首页@3x.37208ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/bottom/首页@3x.png
// module id = 1249
// module chunks = 382